// // client/src/components/media/NewPost.jsx
// // Create a new post - ONLY posts media uploaded in THIS session

// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import AppFooter from "../AppFooter";
// import PostChoiceModal from "./PostChoiceModal";
// import CameraComponent from "./CameraComponent";
// import ImageUploadModal from "./ImageUploadModal";
// import { FaArrowLeft, FaCamera, FaUpload, FaPaperPlane, FaTrash } from "react-icons/fa";
// import { sessionRequestConfig } from "../../services/sessionLocal";

// // Helpers
// const toAbs = (baseUrl, p) =>
//   !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith('/') ? '' : '/'}${p}`;
// const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
// const isImage = (f) =>
//   (f?.mimetype?.startsWith?.("image/")) || /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(f?.path || f || "");
// const isVideo = (f) =>
//   (f?.mimetype?.startsWith?.("video/")) || /\.(mp4|mov|webm|ogg|avi|mkv)$/i.test(f?.path || f || "");

// const NewPost = () => {
//   const { tenant } = useParams();
//   const navigate = useNavigate();
//   const baseUrl = process.env.REACT_APP_BASE_URL || (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");
//   const cfg = sessionRequestConfig();

//   const [timelineEvent, setTimelineEvent] = useState(null);
  
//   // Track ONLY files uploaded in this session
//   const [sessionFiles, setSessionFiles] = useState([]); // Array of {name, url, type}
  
//   const [loading, setLoading] = useState(true);
//   const [showCamera, setShowCamera] = useState(false);
//   const [showUpload, setShowUpload] = useState(false);
//   const [postChoiceOpen, setPostChoiceOpen] = useState(false);

//   // Load Timeline event only (don't load any existing media)
//   useEffect(() => {
//     if (!tenant) return;
//     let alive = true;

//     (async () => {
//       try {
//         const { data: timelineData } = await axios.get(
//           `/api/events/${tenant}/timeline/ensure`,
//           cfg
//         );
//         if (!alive) return;

//         const evt = timelineData?.event;
//         if (!evt?.id) throw new Error("Failed to get Timeline event");

//         setTimelineEvent(evt);
//       } catch (err) {
//         console.error("Error loading:", err);
//       } finally {
//         if (alive) setLoading(false);
//       }
//     })();

//     return () => { alive = false; };
//   }, [tenant]); // eslint-disable-line

//   // Handle Upload - track which files were uploaded
//   const handleUploadComplete = async (files) => {
//     setShowUpload(false);

//     if (!files?.length || !timelineEvent?.id) return;

//     try {
//       // Upload files
//       const fd = new FormData();
//       files.forEach((f) => fd.append("files", f, f.name));

//       await axios.post(
//         `/api/events/${tenant}/${timelineEvent.id}/uploadimage`,
//         fd,
//         {
//           withCredentials: true,
//           headers: { "Content-Type": "multipart/form-data" },
//         }
//       );

//       // Fetch ALL media from event
//       const { data } = await axios.get(
//         // `/api/events/${tenant}/events/${timelineEvent.id}/images`,
//         `/api/events/${tenant}/${timelineEvent.id}/uploadimage`,
//         cfg
//       );

//       const allMedia = data?.images || [];
      
//       // Match uploaded files to returned media by filename
//       const newlyUploaded = [];
      
//       for (const file of files) {
//         // Find matching media by filename in path
//         const matchingMedia = allMedia.find(m => {
//           const path = m.path || m.url || "";
//           return path.includes(file.name);
//         });

//         if (matchingMedia) {
//           newlyUploaded.push({
//             name: file.name,
//             url: matchingMedia.path || matchingMedia.url,
//             type: file.type,
//             mimetype: matchingMedia.mimetype || file.type
//           });
//         }
//       }

//       console.log("📸 Newly uploaded files:", newlyUploaded);

//       // Add to session files (not replace - allow multiple uploads)
//       setSessionFiles(prev => [...prev, ...newlyUploaded]);

//     } catch (e) {
//       console.error("Upload failed:", e);
//       alert("Upload failed: " + (e?.response?.data?.message || e?.message));
//     }
//   };

//   // Handle Camera - fetch the latest media only
//   const handleCameraSaved = async () => {
//     setShowCamera(false);

//     if (!timelineEvent?.id) return;

//     try {
//       // Small delay to let upload complete
//       await new Promise(resolve => setTimeout(resolve, 1000));

//       // Fetch ALL media
//       const { data } = await axios.get(
//         `/api/events/${tenant}/events/${timelineEvent.id}/images`,
//         cfg
//       );

//       const allMedia = data?.images || [];

//       // Get the most recent file (last one in array)
//       if (allMedia.length > 0) {
//         const latestMedia = allMedia[allMedia.length - 1];
        
//         const newFile = {
//           name: latestMedia.path?.split('/').pop() || 'camera',
//           url: latestMedia.path || latestMedia.url,
//           type: latestMedia.mimetype || 'image/jpeg',
//           mimetype: latestMedia.mimetype || 'image/jpeg'
//         };

//         console.log("📷 Camera captured:", newFile);

//         // Add to session files
//         setSessionFiles(prev => [...prev, newFile]);
//       }
//     } catch (err) {
//       console.error("Camera save failed:", err);
//     }
//   };

//   // Handle Post Now - ONLY post session files
//   const handlePostNow = () => {
//     setPostChoiceOpen(false);

//     if (sessionFiles.length === 0) {
//       alert("Please upload or capture media first.");
//       return;
//     }

//     // Build arrays from ONLY session files
//     const selectedImages = sessionFiles
//       .filter(f => isImage(f) || f.mimetype?.startsWith('image/'))
//       .map(f => toPublic(f.url));
    
//     const selectedVideos = sessionFiles
//       .filter(f => isVideo(f) || f.mimetype?.startsWith('video/'))
//       .map(f => toPublic(f.url));

//     const cover = selectedImages[0] || "";

//     console.log("🖼️ Posting images:", selectedImages);
//     console.log("🎥 Posting videos:", selectedVideos);
//     console.log("📋 Total session files:", sessionFiles.length);

//     navigate(`/${tenant}/${timelineEvent.id}/mediaPost`, {
//       state: {
//         context: "timeline",
//         tenant,
//         eventId: timelineEvent.id,
//         title: timelineEvent?.name || "",
//         description: timelineEvent?.description || "",
//         image: cover,
//         images: selectedImages,
//         videos: selectedVideos,
//         event: timelineEvent,
//       },
//       replace: false,
//     });
//   };

//   // Handle Schedule - ONLY schedule session files
//   const handleSchedule = () => {
//     setPostChoiceOpen(false);

//     if (sessionFiles.length === 0) {
//       alert("Please upload or capture media first.");
//       return;
//     }

//     const selectedImages = sessionFiles
//       .filter(f => isImage(f) || f.mimetype?.startsWith('image/'))
//       .map(f => toPublic(f.url));
    
//     const selectedVideos = sessionFiles
//       .filter(f => isVideo(f) || f.mimetype?.startsWith('video/'))
//       .map(f => toPublic(f.url));

//     navigate(`/${tenant}/${timelineEvent.id}/schedulePost`, {
//       state: {
//         context: "timeline",
//         tenant,
//         eventId: timelineEvent.id,
//         title: timelineEvent?.name || "",
//         description: timelineEvent?.description || "",
//         images: selectedImages,
//         videos: selectedVideos,
//         event: timelineEvent,
//       },
//       replace: false,
//     });
//   };

//   // Clear session files
//   const handleClear = () => {
//     if (window.confirm("Clear all media from this post?")) {
//       setSessionFiles([]);
//     }
//   };

//   const footerButtons = [
//     {
//       id: "back",
//       icon: <FaArrowLeft />,
//       label: "Back",
//       onClick: () => navigate(`/${tenant}/post`),
//       disabled: loading,
//     },
//     {
//       id: "camera",
//       icon: <FaCamera />,
//       label: "Camera",
//       onClick: () => setShowCamera(true),
//       disabled: loading || !timelineEvent?.id,
//     },
//     {
//       id: "upload",
//       icon: <FaUpload />,
//       label: "Upload",
//       onClick: () => setShowUpload(true),
//       disabled: loading || !timelineEvent?.id,
//     },
//     {
//       id: "post",
//       icon: <FaPaperPlane />,
//       label: "Post",
//       onClick: () => setPostChoiceOpen(true),
//       disabled: loading || sessionFiles.length === 0,
//     },
//     {
//       id: "clear",
//       icon: <FaTrash />,
//       label: "Clear",
//       onClick: handleClear,
//       disabled: loading || sessionFiles.length === 0,
//     },
//   ];

//   if (loading) {
//     return (
//       <div className="container">
//         <h2 className="hdr hdr--primary hdr--lg">New Post</h2>
//         <div>Loading...</div>
//         <AppFooter buttons={footerButtons} />
//       </div>
//     );
//   }

//   const images = sessionFiles.filter(f => isImage(f) || f.mimetype?.startsWith('image/'));
//   const videos = sessionFiles.filter(f => isVideo(f) || f.mimetype?.startsWith('video/'));

//   return (
//     <div className="container">
//       <h2 className="hdr hdr--primary hdr--lg">New Post</h2>

//       <div className="alert alert-info">
//         Upload or capture media for your new post
//       </div>

//       <div className="form-group">
//         <label>Media ({images.length} photos, {videos.length} videos)</label>
//         {sessionFiles.length === 0 ? (
//           <div className="text-muted">No media yet. Use Camera or Upload.</div>
//         ) : (
//           <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//             {sessionFiles.map((file, i) => {
//               const url = toAbs(baseUrl, file.url);
//               const isVid = isVideo(file) || file.mimetype?.startsWith('video/');

//               return isVid ? (
//                 <video
//                   key={i}
//                   src={url}
//                   style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 8 }}
//                   controls
//                   playsInline
//                 />
//               ) : (
//                 <img
//                   key={i}
//                   src={url}
//                   alt="media"
//                   style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 8 }}
//                 />
//               );
//             })}
//           </div>
//         )}
//       </div>

//       {showCamera && (
//         <CameraComponent
//           tenantId={Number(tenant)}
//           eventId={timelineEvent?.id}
//           eventItemId={null}
//           onClose={() => setShowCamera(false)}
//           onSaved={handleCameraSaved}
//         />
//       )}

//       {showUpload && (
//         <ImageUploadModal
//           onClose={() => setShowUpload(false)}
//           onUploadComplete={handleUploadComplete}
//         />
//       )}

//       {postChoiceOpen && (
//         <PostChoiceModal
//           isOpen={postChoiceOpen}
//           onClose={() => setPostChoiceOpen(false)}
//           onPostNow={handlePostNow}
//           onSchedule={handleSchedule}
//         />
//       )}

//       <AppFooter buttons={footerButtons} />
//     </div>
//   );
// };

// export default NewPost;


// client/src/components/media/NewPost.jsx
// Create a new post - ONLY posts media uploaded in THIS session

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import AppFooter from "../AppFooter";
import PostChoiceModal from "./PostChoiceModal";
import CameraComponent from "./CameraComponent";
import ImageUploadModal from "./ImageUploadModal";
import { FaArrowLeft, FaCamera, FaUpload, FaPaperPlane, FaTrash } from "react-icons/fa";
import { sessionRequestConfig } from "../../services/sessionLocal";

// Helpers
const toAbs = (baseUrl, p) =>
  !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith('/') ? '' : '/'}${p}`;
const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
const isImage = (f) =>
  (f?.mimetype?.startsWith?.("image/")) || /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(f?.path || f || "");
const isVideo = (f) =>
  (f?.mimetype?.startsWith?.("video/")) || /\.(mp4|mov|webm|ogg|avi|mkv)$/i.test(f?.path || f || "");

const NewPost = () => {
  const { tenant } = useParams();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL || (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");
  const cfg = sessionRequestConfig();

  const [timelineEvent, setTimelineEvent] = useState(null);
  
  // Track ONLY files uploaded in this session
  const [sessionFiles, setSessionFiles] = useState([]); // Array of {name, url, type}
  
  const [loading, setLoading] = useState(true);
  const [showCamera, setShowCamera] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [postChoiceOpen, setPostChoiceOpen] = useState(false);

  // Load Timeline event only (don't load any existing media)
  useEffect(() => {
    if (!tenant) return;
    let alive = true;

    (async () => {
      try {
        const { data: timelineData } = await axios.get(
          `/api/events/${tenant}/timeline/ensure`,
          cfg
        );
        if (!alive) return;

        const evt = timelineData?.event;
        if (!evt?.id) throw new Error("Failed to get Timeline event");

        setTimelineEvent(evt);
      } catch (err) {
        console.error("Error loading:", err);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => { alive = false; };
  }, [tenant]); // eslint-disable-line

  // Handle Upload - track which files were uploaded
  const handleUploadComplete = async (files) => {
    setShowUpload(false);

    if (!files?.length || !timelineEvent?.id) return;

    try {
      // Upload files
      const fd = new FormData();
      files.forEach((f) => fd.append("files", f, f.name));

      await axios.post(
        `/api/events/${tenant}/events/${timelineEvent.id}/uploadimage`,
        fd,
        {
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      // Fetch ALL media from event
      const { data } = await axios.get(
        `/api/events/${tenant}/events/${timelineEvent.id}/images`,
        cfg
      );

      const allMedia = data?.images || [];
      
      // Match uploaded files to returned media by filename
      const newlyUploaded = [];
      
      for (const file of files) {
        // Find matching media by filename in path
        const matchingMedia = allMedia.find(m => {
          const path = m.path || m.url || "";
          return path.includes(file.name);
        });

        if (matchingMedia) {
          newlyUploaded.push({
            name: file.name,
            url: matchingMedia.path || matchingMedia.url,
            type: file.type,
            mimetype: matchingMedia.mimetype || file.type
          });
        }
      }

      console.log("📸 Newly uploaded files:", newlyUploaded);

      // Add to session files (not replace - allow multiple uploads)
      setSessionFiles(prev => [...prev, ...newlyUploaded]);

    } catch (e) {
      console.error("Upload failed:", e);
      alert("Upload failed: " + (e?.response?.data?.message || e?.message));
    }
  };

  // Handle Camera - fetch the latest media only
  const handleCameraSaved = async () => {
    setShowCamera(false);

    if (!timelineEvent?.id) return;

    try {
      // Small delay to let upload complete
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Fetch ALL media
      const { data } = await axios.get(
        `/api/events/${tenant}/events/${timelineEvent.id}/images`,
        cfg
      );

      const allMedia = data?.images || [];

      // Get the most recent file (last one in array)
      if (allMedia.length > 0) {
        const latestMedia = allMedia[allMedia.length - 1];
        
        const newFile = {
          name: latestMedia.path?.split('/').pop() || 'camera',
          url: latestMedia.path || latestMedia.url,
          type: latestMedia.mimetype || 'image/jpeg',
          mimetype: latestMedia.mimetype || 'image/jpeg'
        };

        console.log("📷 Camera captured:", newFile);

        // Add to session files
        setSessionFiles(prev => [...prev, newFile]);
      }
    } catch (err) {
      console.error("Camera save failed:", err);
    }
  };

  // Handle Post Now - ONLY post session files
  const handlePostNow = () => {
    setPostChoiceOpen(false);

    if (sessionFiles.length === 0) {
      alert("Please upload or capture media first.");
      return;
    }

    // Build arrays from ONLY session files
    const selectedImages = sessionFiles
      .filter(f => isImage(f) || f.mimetype?.startsWith('image/'))
      .map(f => toPublic(f.url));
    
    const selectedVideos = sessionFiles
      .filter(f => isVideo(f) || f.mimetype?.startsWith('video/'))
      .map(f => toPublic(f.url));

    const cover = selectedImages[0] || "";

    console.log("🖼️ Posting images:", selectedImages);
    console.log("🎥 Posting videos:", selectedVideos);
    console.log("📋 Total session files:", sessionFiles.length);

    navigate(`/${tenant}/${timelineEvent.id}/mediaPost`, {
      state: {
        context: "timeline",
        tenant,
        eventId: timelineEvent.id,
        title: timelineEvent?.name || "",
        description: timelineEvent?.description || "",
        image: cover,
        images: selectedImages,
        videos: selectedVideos,
        event: timelineEvent,
      },
      replace: false,
    });
  };

  // Handle Schedule - ONLY schedule session files
  const handleSchedule = () => {
    setPostChoiceOpen(false);

    if (sessionFiles.length === 0) {
      alert("Please upload or capture media first.");
      return;
    }

    const selectedImages = sessionFiles
      .filter(f => isImage(f) || f.mimetype?.startsWith('image/'))
      .map(f => toPublic(f.url));
    
    const selectedVideos = sessionFiles
      .filter(f => isVideo(f) || f.mimetype?.startsWith('video/'))
      .map(f => toPublic(f.url));

    navigate(`/${tenant}/${timelineEvent.id}/schedulePost`, {
      state: {
        context: "timeline",
        tenant,
        eventId: timelineEvent.id,
        title: timelineEvent?.name || "",
        description: timelineEvent?.description || "",
        images: selectedImages,
        videos: selectedVideos,
        event: timelineEvent,
      },
      replace: false,
    });
  };

  // Clear session files
  const handleClear = () => {
    if (window.confirm("Clear all media from this post?")) {
      setSessionFiles([]);
    }
  };

  const footerButtons = [
    {
      id: "back",
      icon: <FaArrowLeft />,
      label: "Back",
      onClick: () => navigate(`/${tenant}/post`),
      disabled: loading,
    },
    {
      id: "camera",
      icon: <FaCamera />,
      label: "Camera",
      onClick: () => setShowCamera(true),
      disabled: loading || !timelineEvent?.id,
    },
    {
      id: "upload",
      icon: <FaUpload />,
      label: "Upload",
      onClick: () => setShowUpload(true),
      disabled: loading || !timelineEvent?.id,
    },
    {
      id: "post",
      icon: <FaPaperPlane />,
      label: "Post",
      onClick: () => setPostChoiceOpen(true),
      disabled: loading || sessionFiles.length === 0,
    },
    {
      id: "clear",
      icon: <FaTrash />,
      label: "Clear",
      onClick: handleClear,
      disabled: loading || sessionFiles.length === 0,
    },
  ];

  if (loading) {
    return (
      <div className="container">
        <h2 className="hdr hdr--primary hdr--lg">New Post</h2>
        <div>Loading...</div>
        <AppFooter buttons={footerButtons} />
      </div>
    );
  }

  const images = sessionFiles.filter(f => isImage(f) || f.mimetype?.startsWith('image/'));
  const videos = sessionFiles.filter(f => isVideo(f) || f.mimetype?.startsWith('video/'));

  return (
    <div className="container">
      <h2 className="hdr hdr--primary hdr--lg">New Post</h2>

      <div className="alert alert-info">
        Upload or capture media for your new post
      </div>

      <div className="form-group">
        <label>Media ({images.length} photos, {videos.length} videos)</label>
        {sessionFiles.length === 0 ? (
          <div className="text-muted">No media yet. Use Camera or Upload.</div>
        ) : (
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {sessionFiles.map((file, i) => {
              const url = toAbs(baseUrl, file.url);
              const isVid = isVideo(file) || file.mimetype?.startsWith('video/');

              return isVid ? (
                <video
                  key={i}
                  src={url}
                  style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 8 }}
                  controls
                  playsInline
                />
              ) : (
                <img
                  key={i}
                  src={url}
                  alt="media"
                  style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 8 }}
                />
              );
            })}
          </div>
        )}
      </div>

      {showCamera && (
        <CameraComponent
          tenantId={Number(tenant)}
          eventId={timelineEvent?.id}
          eventItemId={null}
          onClose={() => setShowCamera(false)}
          onSaved={handleCameraSaved}
        />
      )}

      {showUpload && (
        <ImageUploadModal
          onClose={() => setShowUpload(false)}
          onUploadComplete={handleUploadComplete}
        />
      )}

      {postChoiceOpen && (
        <PostChoiceModal
          isOpen={postChoiceOpen}
          onClose={() => setPostChoiceOpen(false)}
          onPostNow={handlePostNow}
          onSchedule={handleSchedule}
        />
      )}

      <AppFooter buttons={footerButtons} />
    </div>
  );
};

export default NewPost;